import React from "react";
import { withStyles, Button, Snackbar, withTheme } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/CheckCircleOutline";
import BanIcon from "@material-ui/icons/Block";
import DownIcon from "@material-ui/icons/ArrowDropDown";
import UpIcon from "@material-ui/icons/ArrowDropUp";
import CancelIcon from "@material-ui/icons/Clear";
import appConstants from "../../../../appConstants";
import { compose } from "recompose";
import { postData } from "../../../../api/componentAPIs";
import { withSnackbar } from "notistack";
import MESSAGES from "../../../../appMessages";
import { RMAXLogger } from "../../../../services/LoggerService/RMAXLogger";
import MakeNextStopFeedbackMessage from "../../Dispatch/RouteExecution/DriverPopUp/common/MakeNextStopFeedbackMessage";
const styles = (theme) => ({
  snackBar: {
    top: 100,
  },
  messageContainer: {
    maxWidth: 600,
    minHeight: 80,
    borderRadius: 2,
    backgroundColor: theme.ModalBGColor,
    boxShadow: "0 0px 8px 0 rgba(0,0,0,0.5)",
    display: "inline-flex",
    padding: "16px",
    boxSizing: "border-box",
    userSelect: "none",
    pointerEvents: "all",
  },
  violationMoveColor: {
    color: theme.ErrorMessageColor,
  },
  goodMoveColor: {
    color: theme.HeaderSelectedText,
  },
  badMove: {
    borderLeft: `4px solid ${theme.ErrorMessageColor}`,
  },
  goodMove: {
    borderLeft: `4px solid ${theme.HeaderSelectedText}`,
  },
  moveStatus: {
    boxSizing: "border-box",
    paddingRight: 16,
    height: 48,
  },
  moveMessage: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    paddingLeft: 8,
  },
  moveAffects: {
    display: "inline-flex",
  },
  change: {
    fontSize: 14,
    display: "flex",
    fontWeight: 600,
    paddingRight: 4,
    "&>svg": {
      fontSize: 24,
    },
  },
  moveInfo: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    paddingRight: "10px",
    "&>div": {
      lineHeight: "24px",
    },
  },
  moveAction: {
    display: "flex",
    flexDirection: "column",
  },
  moveIcon: {
    fontSize: 40,
    paddingTop: "4px",
  },
  cancelIcon: {
    float: "right",
    color: theme.gridTextColor,
    cursor: "pointer",
  },
  actionButton: {
    textTransform: "none",
    height: 24,
    borderRadius: 2,
    padding: 0,
    fontSize: theme.textFontSize,
    color: theme.ModalBGColor,
    fontWeight: 600,
    "&$actionDisabled": {
      color: theme.gridTextColor,
    },
  },
  actionDisabled: {
    color: theme.gridTextColor,
  },
  missedApt: {
    paddingLeft: 16,
  },
  missedAptText: {
    color: theme.gridTextColor,
    paddingLeft: 4,
    fontSize: theme.textFontSize,
  },
  stopMarkerClass: {
    height: 20,
    width: 20,
    verticalAlign: "text-bottom",
    "& circle": {
      stroke: "none",
    },
  },
  actionIcon: {
    padding: "0px 16px",
    fontSize: 24,
    verticalAlign: "text-bottom",
  },
  stopName: {
    padding: "0px 8px 0px 16px",
    maxWidth: 150,
    display: "inline-block",
    verticalAlign: "text-bottom",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  tooltipPlacementBottom: {
    margin: 0,
  },
  normalColor: {
    color: theme.gridTextColor,
  },
  stopIcon: {
    display: "inline-flex",
    width: 20,
    height: 20,
    border: `1px solid ${theme.ErrorMessageColor}`,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 4,
  },
  pickupStop: {
    borderRadius: "2px",
  },
  deliveryStop: {
    borderRadius: "10px",
  },
  nextStopMessage: {
    marginLeft: 2,
    marginRight: 8,
  },
});

const getmoveMessage = (props) => {
  const { STOP_MOVES } = appConstants;
  let message = "";
  const { routesAffected } = props.data;
  switch (props.moveType) {
    case STOP_MOVES.RESEQUENCE:
      message = `${routesAffected} Resequenced`;
      break;
    case STOP_MOVES.CHANGE_ROUTE:
      message = `Routes Affected : ${routesAffected}`;
      break;
    case STOP_MOVES.SINGLE_STOP_ROUTECHANGE:
      message = `Stop Moved to a Route`;
      break;
    case STOP_MOVES.SWAP_STOP_SEQ:
      message = `Stop Swapped`;
      break;
    case STOP_MOVES.MARK_NEXT_STOP:
      message = (
        <MakeNextStopFeedbackMessage
          nextStopMarkedData={props.data.nextStopMarkedData}
          updatedStopData={props.data.updatedStopData}
        />
      );
      break;
    default:
      message = `Unknown Move`;
      break;
  }
  return message;
};

function onStopMoveUndo(props) {
  const requestObj = {
    scenarioId: props.data.scenarioId,
    scenarioVersionId: props.data.scenarioVersionId,
  };
  props.onClose();
  props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [true]);
  postData("Undo", requestObj).then(
    (response) => {
      if (response && response.status >= 200 && response.status < 400) {
        props.selectedRouteList
          ? props.refreshData(props.selectedRouteList)
          : props.refreshData();
        props.enqueueSnackbar(MESSAGES.STOP_MOVE_UNDO.SUCCESS, {
          variant: "success",
        });
      } else {
        handleError(response?.response?.status ?? response.status);
      }
    },
    () => {
      handleError();
    }
  );

  RMAXLogger.info("StopsMoveUndo");
}

const handleError = (statusCode) => {
  if (statusCode !== 409) {
    props.glEventHub.emit("UpdateIBStore", "setdisableStoreUpdate", [false]);
  }
  if (statusCode !== 403) {
    props.enqueueSnackbar(MESSAGES.STOP_MOVE_UNDO.FAILURE, {
      variant: "error",
    });
  }
}

const getViolationClassName = (isViolationMove, classes) => {
  return isViolationMove ? classes.normalColor : classes.goodMoveColor;
};

const FeedbackComponent = (props) => {
  const { totalMiles, totalTime, totalCost=null, numServiceViolations } = props.data;
  const isViolationMove =
    totalMiles > 0 ||
    totalTime > 0 ||
    totalCost > 0 ||
    numServiceViolations > 0;
  const { classes, hideUndo, hideCostKpi = false } = props;
  const hideCostKpiFlag = hideCostKpi || (totalCost === null ? true : false);
  return (
    <div
      className={`${classes.messageContainer} ${
        isViolationMove ? classes.badMove : classes.goodMove
      }`}
    >
      <div className={classes.moveStatus}>
        {isViolationMove ? (
          <BanIcon
            classes={{
              root: `${classes.moveIcon} ${classes.violationMoveColor}`,
            }}
          />
        ) : (
          <CheckIcon
            classes={{ root: `${classes.moveIcon} ${classes.goodMoveColor}` }}
          />
        )}
      </div>
      <div className={classes.moveInfo}>
        <div className={classes.moveMessage}>{getmoveMessage(props)}</div>
        <div className={classes.moveAffects}>
          <div
            className={`${classes.change} ${
              totalMiles > 0
                ? classes.violationMoveColor
                : getViolationClassName(isViolationMove, classes)
            }`}
          >
            {totalMiles >= 0 ? <UpIcon /> : <DownIcon />}
            <div> {Math.abs(totalMiles || 0).toFixed(1)} mi </div>
          </div>
          <div
            className={`${classes.change} ${
              totalTime > 0
                ? classes.violationMoveColor
                : getViolationClassName(isViolationMove, classes)
            }`}
          >
            {totalTime >= 0 ? <UpIcon /> : <DownIcon />}
            <div> {Math.abs(totalTime || 0)} mins </div>
          </div>
          {!hideCostKpiFlag && (
            <div
              className={`${classes.change} ${
                totalCost > 0
                  ? classes.violationMoveColor
                  : getViolationClassName(isViolationMove, classes)
              }`}
            >
              {totalCost >= 0 ? <UpIcon /> : <DownIcon />}
              <div> ${Math.abs(totalCost || 0).toFixed(1)} </div>
            </div>
          )}
          <div
            className={`${classes.change} ${classes.missedApt} ${
              numServiceViolations > 0
                ? classes.violationMoveColor
                : getViolationClassName(isViolationMove, classes)
            }`}
          >
            {numServiceViolations || 0}
            <div className={classes.missedAptText}> Missed Apts </div>
          </div>
        </div>
      </div>
      <div className={classes.moveAction}>
        <div className={classes.actionButton}>
          <CancelIcon
            classes={{ root: classes.cancelIcon }}
            onClick={(event) => props.onClose && props.onClose(event)}
          />
        </div>
        {!hideUndo && (
          <Button
            size="small"
            color="primary"
            variant="contained"
            classes={{
              root: classes.actionButton,
              disabled: classes.actionDisabled,
            }}
            onClick={() => onStopMoveUndo(props)}
          >
            Undo
          </Button>
        )}
      </div>
    </div>
  );
};

export default compose(
  withStyles(styles),
  withTheme(),
  withSnackbar
)(FeedbackComponent);
